import React from "react";
import PropTypes from "prop-types";
import { Modal, Grid, Button, Tooltip, Box, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import { ButtonWrapper, LoaderWrapper } from "./styles";
import CircleLoader from "../Loaders/CircleLoader";
import ComboHeader from "../ComboHeader/ComboHeader";

export const DetailsModal = ({
  open,
  onClose,
  content,
  exportTableId,
  onExport,
  loadingExcel,
  notFullHd,
}) => {
  return (
    <Modal open={open} onClose={onClose}>
      <Grid
        className="card"
        container
        flexDirection="column"
        justifyContent="center"
        sx={{
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          position: "absolute",
          height: "84%",
          width: notFullHd ? "70%" : "75%",
        }}
      >
        <Grid
          container
          item
          flexDirection="row"
          justifyContent="space-between"
          alignItems="center"
          sx={{ width: "100%", maxWidth: "100%" }}
        >
          <Grid item xs>
            <ComboHeader
              reference={{
                title: {
                  hard: "Detalhes",
                },
              }}
            />
          </Grid>
          <Grid
            item
            container
            flexDirection="row"
            justifyContent="flex-end"
            alignItems="flex-start"
            xs
            sx={{ paddingBottom: "18px" }}
          >
            <Tooltip title="Exportar para Excel">
              <Button
                type="button"
                variant="outlined"
                onClick={onExport}
                endIcon={<FileDownloadOutlinedIcon />}
                className="export-button"
              >
                {loadingExcel ? (
                  <LoaderWrapper>
                    <CircleLoader />
                  </LoaderWrapper>
                ) : (
                  <Box component="span" />
                )}
              </Button>
            </Tooltip>
            <ButtonWrapper>
              <Tooltip title="Fechar">
                <IconButton onClick={onClose}>
                  <CloseIcon />
                </IconButton>
              </Tooltip>
            </ButtonWrapper>
          </Grid>
        </Grid>
        <Grid className="cardContentArea" item sx={{ height: "100%" }} xs>
          {content}
        </Grid>
      </Grid>
    </Modal>
  );
};

DetailsModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  content: PropTypes.node.isRequired,
  exportTableId: PropTypes.string,
  onExport: PropTypes.func.isRequired,
  loadingExcel: PropTypes.bool.isRequired,
  notFullHd: PropTypes.bool.isRequired,
};
